import { render, staticRenderFns } from "./ModalEliminarCertificado.vue?vue&type=template&id=46d208af&scoped=true"
import script from "./ModalEliminarCertificado.vue?vue&type=script&lang=js"
export * from "./ModalEliminarCertificado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d208af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46d208af')) {
      api.createRecord('46d208af', component.options)
    } else {
      api.reload('46d208af', component.options)
    }
    module.hot.accept("./ModalEliminarCertificado.vue?vue&type=template&id=46d208af&scoped=true", function () {
      api.rerender('46d208af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizacion/usuario/ModalEliminarCertificado.vue"
export default component.exports